module.exports = __webpack_public_path__ + "img/tf24.89f71205.jpg";